<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/match")
          i.fa.fa-gamepad
          span.ml-1 {{ $t("ui.match") }}
      b-breadcrumb-item
        router-link(to="/match/remapmatch")
          i.fas.fa-link
          span.ml-1 {{ $t("ui.remap_match") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-basketball-ball
                    b-form-select(v-model="sportType" autofocus)
                      //- option(value=0)
                      //-   | {{ $t("ui.all") }}
                      option(v-for="sportInfo in sportList" v-bind:value="sportInfo.sport_id")
                        | {{ sportInfo.sport_type }}
                div.col-md-4.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-search
                    DebounceInput(required type="text" v-model="remapMatchSearch" :placeholder="$t('message.search_by_league_name')")
                div.col-md-2.mb-1
                  b-form-radio-group(
                    buttons
                    v-model="filterBy"
                    size="sm"
                    button-variant="outline-info"
                  )
                    b-form-radio(value="id") {{ $t("ui.match_id") }}
                    b-form-radio(value="name") {{ $t("ui.league_name") }}
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.far.fa-clock
                    b-form-select(v-model="marketType" @change="marketOnChange($event)")
                      option(value="") {{ $t('ui.all') }}
                      option(value="early") {{ $t('ui.early') }}
                      option(value="today") {{ $t('ui.today') }}
                      option(value="live") {{ $t("ui.live") }}
                //- div.col-md-3.mb-1
                //-   b-input-group(size="sm")
                //-     b-input-group-text(slot="prepend")
                //-       i.fas.fa-sort
                //-     b-form-select(v-model="sortKey")
                //-       option(value="match_id") {{ $t('ui.id') }}
                //-       option(value="sport_type") {{ $tc('ui.sports', 1) }}
                //-       option(value="league_name") {{ $tc("ui.leagues", 1) }}
                //-       option(value="match_date") {{ $t("ui.match_date") }}
                //-     b-form-select(v-model="sortType")
                //-       option(value="asc") {{ $t("ui.ascending") }}
                //-       option(value="desc") {{ $t("ui.descending") }}
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.from") }}
                    date-picker(v-model="startDate" :config="locale")
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.to") }}
                    date-picker(v-model="endDate" :config="locale")
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.linked") }}
                    b-form-select(v-model="linked")
                      option(value="") {{ $t('ui.all') }}
                      option(value="true") {{ $t('ui.linked') }}
                      option(value="false") {{ $t('ui.not_linked') }}
                div.col-md-2.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getLinkedMatchList(true)"
                    variant="success"
                    size="sm"
                    ).mr-2
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-link"
                    :text="$t('ui.remap')"
                    type="button"
                    @click="remapMatch()"
                    variant="secondary"
                    size="sm"
                    v-if="unmatchIdSelected !=''"
                  ).mr-2
                div.col-md-2.mb-1
                  SubmitButton.float-right(
                    :loading="loading"
                    icon="fa fa-link"
                    :text="$t('ui.swap')"
                    type="button"
                    @click="swapRemapMatch()"
                    variant="warning"
                    size="sm"
                    v-if="unmatchIdSelected !='' && ibcMatchInfo && sboMatchInfo"
                  )
        div.card-body
          div(v-if="pageLvl == 'master'")
            div.row
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="linkedMatchTotalRow"
                  :per-page="getPageSize"
                  v-model="currentLinkedMatchPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
                  b-input(:value="linkedMatchTotalRow" readonly)
            div.row.clusterize
              div.col-md-12
                .clusterize-scroll
                  table.tablex.resizable(style="width: 100%;")
                    thead
                      tr
                        th.sticky-position(width=100 @click="sortOrder('match_id', 'master')")
                          span {{ $t('ui.id') }}
                          i(:class="changeSortKey('match_id', 'master')")
                        th.sticky-position(width=80 @click="sortOrder('sport_type', 'master')")
                          span {{ $tc('ui.sports', 1) }}
                          i(:class="changeSortKey('sport_type', 'master')")
                        th.sticky-position(@click="sortOrder('sbo_league_name', 'master')")
                          span {{ $tc("ui.leagues", 1) }} ({{ $t("ui.sbo") }})
                          i(:class="changeSortKey('sbo_league_name', 'master')")
                        th.sticky-position
                          span {{ $t("ui.home") }} ({{ $t("ui.sbo") }})
                        th.sticky-position
                          span {{ $t("ui.home") }} ({{ $t("ui.ibc") }})
                        th.sticky-position
                          span {{ $t("ui.away") }} ({{ $t("ui.sbo") }})
                        th.sticky-position
                          span {{ $t("ui.away") }} ({{ $t("ui.ibc") }})
                        th.sticky-position(width=120 @click="sortOrder('created_on', 'master')")
                          span {{ $t("ui.mapped_time") }}
                          i(:class="changeSortKey('created_on', 'master')")
                        th.sticky-position(width=60)
                          span(:title="$t('ui.market_type')") {{ $t("ui.short.market_type") }}
                        th.sticky-position(width=80 @click="sortOrder('match_date_time', 'master')")
                          span {{ $t("ui.short.match_date") }}
                          i(:class="changeSortKey('match_date_time', 'master')")
                        th.sticky-position(width=80)
                          span {{ $t("ui.short.match_time") }}
                        th.sticky-position(width=70)
                          span {{ $t("ui.sbo") }}
                        th.sticky-position(width=70)
                          span {{ $t("ui.ibc") }}
                        th.sticky-position(width=70)
                          span {{ $t("ui.linked") }}
                        th.text-center.sticky-position(width=80)
                          span {{ $t("ui.action") }}
                    tbody.clusterize-content
                      tr(v-if="linkedMatchList.length == 0")
                        td(colspan="15").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in linkedMatchList")
                        td
                          span {{ item.match_id }}
                        td
                          span {{ item.sport_type }}
                        td
                          span(:title="item.ibc_league_name") {{ item.sbo_league_name }}
                        td
                          span(:title="item.sbo_home_team") {{ item.sbo_home_team }}
                        td
                          span(:title="item.ibc_home_team") {{ item.ibc_home_team }}
                        td
                          span(:title="item.sbo_away_team") {{ item.sbo_away_team }}
                        td
                          span(:title="item.ibc_away_team") {{ item.ibc_away_team }}
                        td
                          span {{ $moment(item.created_on).format("YYYY-MM-DD HH:mm:ss") }}
                        td.text-uppercase
                          span {{ item.market_type }}
                        td
                          span {{ getDate(item.match_date) }}
                        td
                          span {{ item.match_time }}
                        td
                          span {{ item.sbo_map }}
                        td
                          span {{ item.ibc_map }}
                        td
                          span {{ item.link_id }}
                        td.actions
                          span
                            a.fa.fa-edit.text-primary(href="#" @click="onEdit(item)" :title="$t('ui.edit')")
          div(v-if="pageLvl == 'detail'")
            div(style="height: 650px;")
              div.row.mb-1
                div.col
                  SubmitButton(
                    :loading="loading"
                    icon="icon-arrow-left"
                    :text="$t('ui.back')"
                    type="button"
                    @click="backToMaster"
                    variant="secondary"
                    size="sm"
                    ).mb-1
              div.row.mb-1(v-if="matchInfo")
                div.col
                  b-form-group(:label="$t('ui.current_match')").mb-3
                    div.row.mb-1.animated.fadeIn
                      div.col
                        table.tablex(style="width: 100%;" v-columns-resizable)
                          thead
                            tr
                              th.sticky-position(width=80)
                                span {{ $t('ui.id') }}
                              th.sticky-position(width=80)
                                span {{ $tc('ui.sports', 1) }}
                              th.sticky-position
                                span {{ $tc("ui.leagues", 1) }}
                              th.sticky-position
                                span {{ $t("ui.home") }}
                              th.sticky-position
                                span {{ $t("ui.away") }}
                              th.sticky-position(width=60)
                                span(:title="$t('ui.market_type')") {{ $t("ui.short.market_type") }}
                              th.sticky-position(width=80)
                                span {{ $t("ui.short.match_date") }}
                              th.sticky-position(width=80)
                                span {{ $t("ui.short.match_time") }}
                              th.sticky-position(width=80)
                                span {{ $t("ui.sbo") }}
                              th.sticky-position(width=80)
                                span {{ $t("ui.ibc") }}
                          tbody.clusterize-content
                            tr
                              td
                                span {{ matchInfo.match_id }}
                              td
                                span {{ matchInfo.sport_type }}
                              td
                                span(:title="matchInfo.league_name") {{ matchInfo.league_name }}
                              td
                                span(:title="matchInfo.home_team") {{ matchInfo.home_team }}
                              td
                                span(:title="matchInfo.away_team") {{ matchInfo.away_team }}
                              td.text-uppercase
                                span {{ matchInfo.market_type }}
                              td
                                span {{ $moment(matchInfo.match_date).format("YYYY-MM-DD") }}
                              td
                                span {{ matchInfo.match_time }}
                              td
                                span {{ matchInfo.sbo_map }}
                              td
                                span {{ matchInfo.ibc_map }}
              div.row.mb-1
                div.col
                  div.row
                    div.col-md-6.clusterize.animated.fadeIn
                      div(v-if="sboMatchInfo")
                        b-form-group(:label="$t('ui.sbo_match')").mb-3
                          div.row.mb-1
                            div.col
                              table.tablex(v-columns-resizable)
                                thead
                                  tr
                                    th.sticky-position(width=50)
                                      span {{ $t('ui.id') }}
                                    th.sticky-position(width=80)
                                      span {{ $tc('ui.sports', 1) }}
                                    th.sticky-position
                                      span {{ $tc('ui.leagues', 1) }}
                                    th.sticky-position(width=90)
                                      span {{ $t('ui.match_date') }}
                                    th.sticky-position
                                      span {{ $t('ui.home') }}
                                    th.sticky-position
                                      span {{ $t('ui.away') }}
                                    th.text-center.sticky-position(width=80)
                                      span {{ $t("ui.action") }}
                                tbody.clusterize-content
                                  tr
                                    td
                                      span {{ sboMatchInfo.match_id }}
                                    td
                                      span {{ sboMatchInfo.sport_type }}
                                    td
                                      span(:title="sboMatchInfo.league_name + ' [' + sboMatchInfo.league_id + ']'") {{ sboMatchInfo.league_name }}
                                    td
                                      span {{ getDate(sboMatchInfo.match_date) }}
                                    td
                                      span(:title="sboMatchInfo.home_team + ' [' + sboMatchInfo.home_id + ']'") {{ sboMatchInfo.home_team }}
                                    td
                                      span(:title="sboMatchInfo.away_team + ' [' + sboMatchInfo.away_id + ']'") {{ sboMatchInfo.away_team }}
                                    td.actions
                                      span
                                        a.fa.fa-unlink.text-primary(href="#" @click="unmapMatch(sboMatchInfo, 'sbo')" :title="$t('ui.unmap')")
                      div(v-if="ibcMatchInfo")
                        b-form-group(:label="$t('ui.ibc_match')").mb-3
                          div.row.mb-1
                            div.col
                              table.tablex(v-columns-resizable)
                                thead
                                  tr
                                    th.sticky-position(width=50)
                                      span {{ $t('ui.id') }}
                                    th.sticky-position(width=80)
                                      span {{ $tc('ui.sports', 1) }}
                                    th.sticky-position
                                      span {{ $tc('ui.leagues', 1) }}
                                    th.sticky-position(width=90)
                                      span {{ $t('ui.match_date') }}
                                    th.sticky-position
                                      span {{ $t('ui.home') }}
                                    th.sticky-position
                                      span {{ $t('ui.away') }}
                                    th.text-center.sticky-position(width=80)
                                      span {{ $t("ui.action") }}
                                tbody.clusterize-content
                                  tr
                                    td
                                      span {{ ibcMatchInfo.match_id }}
                                    td
                                      span {{ ibcMatchInfo.sport_type }}
                                    td
                                      span(:title="ibcMatchInfo.league_name + ' [' + ibcMatchInfo.league_id + ']'") {{ ibcMatchInfo.league_name }}
                                    td
                                      span {{ getDate(ibcMatchInfo.match_date) }}
                                    td
                                      span(:title="ibcMatchInfo.home_team + ' [' + ibcMatchInfo.home_id + ']'") {{ ibcMatchInfo.home_team }}
                                    td
                                      span(:title="ibcMatchInfo.away_team + ' [' + ibcMatchInfo.away_id + ']'") {{ ibcMatchInfo.away_team }}
                                    td.actions
                                      span
                                        a.fa.fa-unlink.text-primary(href="#" @click="unmapMatch(ibcMatchInfo, 'ibc')" :title="$t('ui.unmap')")
                    div.col-md-6.clusterize.animated.fadeIn.mt-3(v-if="sboMatchInfo || ibcMatchInfo")
                      div.row.mb-2
                        div.col-md-2
                          b-input-group(size="sm")
                            b-form-select(v-model="provider")
                              option(value="SBO") {{ $t('ui.sbo') }}
                              option(value="IBC") {{ $t('ui.ibc') }}
                            b-input(:value="filterUnmatchListLength" readonly)
                        div.col-md-6
                          b-input-group(size="sm")
                            b-input-group-text(slot="prepend")
                              i.fas.fa-search
                            DebounceInput(required type="text" v-model="unmatchSearch" :placeholder="$t('message.search_by_team_name')").mr-1
                            b-form-radio-group(
                              buttons
                              v-model="unmatchFilterBy"
                              size="sm"
                              button-variant="outline-info"
                            )
                              b-form-radio(value="match_id") {{ $t("ui.id") }}
                              b-form-radio(value="league_name") {{ $tc("ui.leagues", 1) }}
                              b-form-radio(value="home_team") {{ $t("ui.home") }}
                              b-form-radio(value="away_team") {{ $t("ui.away") }}
                      div.row.mb-1
                        div.col-12.clusterize
                          div.clusterize-scroll(style="max-height: 450px;")
                            table.tablex(v-columns-resizable)
                              thead
                                tr
                                  th.sticky-position(width=50 @click="sortOrder('match_id', 'detail')")
                                    span {{ $t('ui.id') }}
                                    i(:class="changeSortKey('match_id', 'detail')")
                                  th.sticky-position(width=80 @click="sortOrder('sport_type', 'detail')")
                                    span {{ $tc('ui.sports', 1) }}
                                    i(:class="changeSortKey('sport_type', 'detail')")
                                  th.sticky-position(@click="sortOrder('league_name', 'detail')")
                                    span {{ $tc('ui.leagues', 1) }}
                                    i(:class="changeSortKey('league_name', 'detail')")
                                  th.sticky-position(width=90 @click="sortOrder('match_date', 'detail')")
                                    span {{ $t('ui.match_date') }}
                                    i(:class="changeSortKey('match_date', 'detail')")
                                  th.sticky-position
                                    span {{ $t('ui.home') }}
                                  th.sticky-position
                                    span {{ $t('ui.away') }}
                              tbody.clusterize-content
                                tr(
                                  v-for="(item, index) in filterUnmatchList"
                                  @click="rowSelect(item)"
                                  :class="{ 'selectedRow' : selectedRow(item) }"
                                  )
                                  td
                                    span {{ item.match_id }}
                                  td
                                    span {{ item.sport_type }}
                                  td
                                    span(:title="item.league_name + ' [' + item.league_id + ']'") {{ item.league_name }}
                                  td
                                    span {{ getDate(item.match_date) }}
                                  td
                                    span(:title="item.home_team + ' [' + item.home_id + ']'") {{ item.home_team }}
                                  td
                                    span(:title="item.away_team + ' [' + item.away_id + ']'") {{ item.away_team }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import {resizeColumn} from '@/main';

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  data: () => ({
    loading: false,
    matchInfo: null,
    sboMatchInfo: null,
    ibcMatchInfo: null,
    sportType: 1,
    sportList: [],
    linkedMatchList: [],
    sboMatchList: [],
    ibcMatchList: [],
    currentLinkedMatchPage: 1,
    linkedMatchTotalRow: 0,
    remapMatchSearch: "",
    marketType: "today",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    startDate: null,
    endDate: null,
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    pageLvl: 'master',
    provider: 'IBC',
    masterSortKey: "created_on",
    masterSortType: "asc",
    detailSortKey: "league_name",
    detailSortType: "asc",
    unmatchFilterBy: 'league_name',
    unmatchSearch: "",
    unmatchIdSelected: "",
    firstProvider: "SBO",
    secondProvider: "IBC",
    linked: "",
    filterBy: "name"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    today() {
      return this.$moment(new Date).format('YYYY-MM-DD');
    },
    todayWD() {
      return this.$moment(new Date).add(-12, 'hours').format('YYYY-MM-DD');
    },
    tomorrowWD() {
      return this.$moment(new Date).add(1, 'days').add(-12, 'hours').format('YYYY-MM-DD');
    },
    yesterday() {
      return this.$moment(new Date).add(-1, 'days').format('YYYY-MM-DD');
    },
    unmatchList:
    {
      get() {
        if (this.provider.toLowerCase() == 'sbo') {
          return this.sboMatchList;
        }
        else if (this.provider.toLowerCase() == 'ibc') {
          return this.ibcMatchList;
        }

        return [];
      },
      set(value)
      {
        this.value = value
      }
    },
    filterUnmatchListLength() {
      if (this.filterUnmatchList) {
        return this.filterUnmatchList.length;
      } else {
        return 0;
      }
    },
    filterUnmatchList:
    {
      get() {
        return this.unmatchList.filter(item => {
          if (this.unmatchFilterBy == "league_name") return item.league_name.toLowerCase().indexOf(this.unmatchSearch.toLowerCase()) > -1;
          else if (this.unmatchFilterBy == "home_team") return item.home_team.toLowerCase().indexOf(this.unmatchSearch.toLowerCase()) > -1;
          else if (this.unmatchFilterBy == "away_team") return item.away_team.toLowerCase().indexOf(this.unmatchSearch.toLowerCase()) > -1;
          else if (this.unmatchFilterBy == "match_id") return item.match_id.toString().indexOf(this.unmatchSearch.toLowerCase()) > -1;
        })
        .sort((a, b) => {
          if (this.detailSortType == 'asc')
            return a[this.detailSortKey] > b[this.detailSortKey] ? 1 : -1;
          else
            return a[this.detailSortKey] < b[this.detailSortKey] ? 1 : -1;
        });
      },
      set(value)
      {
        this.value = value
      }
    }
  },
  mounted: function() {
    this.getSportList();
    this.startDate = this.yesterday;
    this.endDate = this.today;
    resizeColumn();
  },
  methods: {
    marketOnChange(eventStatus) {
      if (eventStatus == '') {
        this.startDate = this.yesterday;
        this.endDate = this.today;
      }
      else if (eventStatus == 'early') {
        this.startDate = this.tomorrowWD;
        this.endDate = this.tomorrowWD;
      } else if (eventStatus == 'today' || eventStatus == 'live') {
        this.startDate = this.todayWD;
        this.endDate = this.todayWD;
      }
    },
    sortOrder(key, type) {
      if (type == 'master') {
        if (this.masterSortKey == key)
          this.masterSortType = this.masterSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.masterSortKey = key;
          this.masterSortType = 'asc';
        }
      } else if (type == 'detail') {
        if (this.detailSortKey == key)
          this.detailSortType = this.detailSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.detailSortKey = key;
          this.detailSortType = 'asc';
        }
      }

      this.getLinkedMatchList(true);
    },
    changeSortKey(key, type) {
      if (type == 'master') {
        if (this.masterSortKey != key)
          return 'fas fa-sort';
        else if (this.masterSortKey == key && this.masterSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.masterSortKey == key && this.masterSortType == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'detail') {
        if (this.detailSortKey != key)
          return 'fas fa-sort';
        else if (this.detailSortKey == key && this.detailSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.detailSortKey == key && this.detailSortType == 'desc')
          return 'fa fa-sort-down';
      }
    },
    getDate(dateTime) {
      let convertDateFormat = this.$moment(dateTime).format("YYYY-MM-DD");
      return convertDateFormat;
    },
    getSportList: function() {
      let url = config.sportListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.remapmatch
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sportList = response.data.tbl_sport_list;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getLinkedMatchList: function(isSearch) {
      this.pageLvl = "master";

      let url = config.matchListUrl();

      // reset current page to 1 when "Search" button is clicked..
      if (isSearch) this.currentLinkedMatchPage = 1;

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.remapmatch,
        sport_id: this.sportType,
        market_type: this.marketType,
        match_date_from: this.$moment(this.startDate).format("YYYY-MM-DD"),
        match_date_to: this.$moment(this.endDate).format("YYYY-MM-DD"),
        league_id_str: '',
        linked: this.linked == '' ? null : this.linked,
        sort_key: this.masterSortKey,
        sort_type: this.masterSortType,
        page_number: this.currentLinkedMatchPage,
        page_size: this.getPageSize,
        pagination: true
      };

      if (this.filterBy == "id") {
        json.match_id = this.remapMatchSearch;
      } else {
        json.league_name = this.remapMatchSearch;
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.linkedMatchList = response.data.tbl_match_list;
                this.linkedMatchTotalRow = this.linkedMatchList.length > 0 ? this.linkedMatchList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onEdit(item) {
      this.pageLvl = "detail";
      this.provider = "IBC";
      this.matchInfo = item;
      this.getProviderMatchList(item);
      this.getMatchList();
    },
    unmapMatch: function(item, provider) {
      this.$helpers
        .alert({
          title: this.$t("ui.unmap_match"),
          text: this.$t("message.unmap_match_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmUnmapMatch(item, provider);
          }
        });
    },
    confirmUnmapMatch(item, provider) {
      if (this.sboMatchInfo && this.ibcMatchInfo) {
        let url = config.unmapSingleMatchUrl();

        var json = {
          action_by: this.$store.getters.username,
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.remapmatch,
          match_id: this.matchInfo.match_id,
          provider: provider,
          sbo_match: this.sboMatchInfo.match_id,
          ibc_match: this.ibcMatchInfo.match_id
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.backToMaster();

                  this.$snotify.success(this.$t("message.success"));
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.isSingleProviderMatch"), "error");
      }
    },
    getProviderMatchList(item) {
      let url = config.providerMatchListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.remapmatch,
        sbo_match: item.sbo_map,
        ibc_match: item.ibc_map
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if (response.data.tbl_provider_match_list.Table.length > 0)
                  this.sboMatchInfo = response.data.tbl_provider_match_list.Table[0];

                if (response.data.tbl_provider_match_list.Table1.length > 0)
                  this.ibcMatchInfo = response.data.tbl_provider_match_list.Table1[0];

              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getMatchList() {
      let url = config.mapMatchListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.remapmatch,
        sport_id: this.sportType,
        linked: false,
        map_from: this.firstProvider.toLowerCase(),
        map_to: this.secondProvider.toLowerCase(),
        market_type: this.marketType,
        match_date_from: this.startDate,
        match_date_to: this.endDate,
        ignore_date_range: false
        // sort_key: this.sortKey,
        // sort_type: this.sortType
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // Success
          this.loading = false;
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sboMatchList = [];
                this.ibcMatchList = [];
                this.sboMatchList = response.data.tbl_map_match_list.Table;
                this.ibcMatchList = response.data.tbl_map_match_list.Table1;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    selectedRow: function(info) {
      if (this.unmatchIdSelected == info.match_id) return true;

      return false;
    },
    rowSelect: function(matchInfo) {
      setTimeout(() => {
        this.unmatchIdSelected = matchInfo.match_id;
      }, 1);
    },
    remapMatch: function() {
      this.$helpers
        .alert({
          title: this.$t("ui.remap_match"),
          text: this.$t("message.remap_match_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmRemapMatch(false);
          }
        });
    },
    confirmRemapMatch: function(isSwap) {
      let url = "";

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.remapmatch,
        match_id: this.matchInfo.match_id
      };

      if (this.firstProvider.toLowerCase() == "sbo" && this.secondProvider.toLowerCase() == "ibc") {
        url = isSwap ? config.remapSwapMatchManualSBOIBCUrl() : config.remapMatchManualSBOIBCUrl();
        if (this.provider.toLowerCase() == 'sbo') {
          json.sbo_match = this.unmatchIdSelected;
          json.ibc_match = this.ibcMatchInfo ? this.ibcMatchInfo.match_id : null ;
        }
        else if (this.provider.toLowerCase() == 'ibc') {
          json.sbo_match = this.sboMatchInfo ? this.sboMatchInfo.match_id : null;
          json.ibc_match = this.unmatchIdSelected;
        }
      }

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {

                this.backToMaster();

                this.$snotify.success(this.$t("message.success"));
              } else {
                this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    swapRemapMatch: function() {
      var firstMatchSelected = {};
      var secondMatchSelected = {};
      if (this.provider.toLowerCase() == 'sbo') {
        firstMatchSelected = this.unmatchList.filter(item => {
          return item.match_id == this.unmatchIdSelected;
        })[0];
        secondMatchSelected = this.ibcMatchInfo;
      } else if (this.provider.toLowerCase() == 'ibc') {
        firstMatchSelected = this.sboMatchInfo;
        secondMatchSelected = this.unmatchList.filter(item => {
          return item.match_id == this.unmatchIdSelected;
        })[0];
      }

      this.$helpers
        .alert({
          title: this.$t("ui.combine.swap_remap_match"),
          width: 1300,
          html:
            '<div class="col">' +
            '<div class="row">' +
            '<div class="col-md-12 mb-3">' +
            '<span>'+ this.$t("message.swap_remap_match_confirm") +'</span>' +
            '</div>' +
            '</div>' +
            '<div class="row">' +
            '<div class="col-md-1 mb-1">' +
            '<span>'+ this.$t("ui.sbo") +'</span>' +
            '</div>' +
            '</div>' +
            '<div class="row mb-2">' +
            '<div class="col-md-12">' +
            '<table class="tablex" style="width: 100%;">' +
            '<thead><tr>' +
            '<th class="sticky-position" style="width: 60%;"><span>' + this.$tc("ui.leagues", 1) + '</span></th>' +
            '<th class="sticky-position" style="width: 20%;"><span>' + this.$t("ui.home") + '</span></th>' +
            '<th class="sticky-position" style="width: 20%;"><span>' + this.$t("ui.away") + '</span></th>' +
            '</tr></thead>' +
            '<tbody><tr>' +
            '<td><span>' + firstMatchSelected.league_name + '</span></td>' +
            '<td><span>' + firstMatchSelected.home_team + '</span></td>' +
            '<td><span>' + firstMatchSelected.away_team + '</span></td>' +
            '</tr></tbody>' +
            '</table>' +
            '</div>' +
            '</div>' +

            '<div class="row">' +
            '<div class="col-md-1 mb-1">' +
            '<span>'+ this.$t("ui.ibc") +'</span>' +
            '</div>' +
            '</div>' +
            '<div class="row">' +
            '<div class="col-md-12">' +
            '<table class="tablex" style="width: 100%;">' +
            '<thead><tr>' +
            '<th class="sticky-position" style="width: 60%;"><span>' + this.$tc("ui.leagues", 1) + '</span></th>' +
            '<th class="sticky-position" style="width: 20%;"><span>' + this.$t("ui.home") + '</span></th>' +
            '<th class="sticky-position" style="width: 20%;"><span>' + this.$t("ui.away") + '</span></th>' +
            '</tr></thead>' +
            '<tbody><tr>' +
            '<td><span>' + secondMatchSelected.league_name + '</span></td>' +
            '<td><span>' + secondMatchSelected.home_team + '</span></td>' +
            '<td><span>' + secondMatchSelected.away_team + '</span></td>' +
            '</tr></tbody>' +
            '</table>' +
            '</div>' +
            '</div>' +
            '</div>',
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmRemapMatch(true);
          }
        });
    },
    backToMaster: function() {
      this.pageLvl = "master";
      this.unmatchIdSelected = "";
      this.unmatchList = [];
      this.unmatchSearch = "";
      this.matchInfo = null;
      this.sboMatchInfo = null;
      this.ibcMatchInfo = null;
      this.provider = 'SBO';
      this.getLinkedMatchList();
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentLinkedMatchPage = 1;
      this.getLinkedMatchList();
    },
    changedPage: function(pageNo) {
      this.currentLinkedMatchPage = pageNo;
      this.getLinkedMatchList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
tr,
td {
  cursor: pointer;
}
</style>